import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MediumRiskIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 50, 50);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      {...a11y}
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0319 5C26.3898 5 27.4906 6.09576 27.4906 7.44744C27.4906 8.48792 26.8379 9.37558 25.9182 9.7297L26.3055 11.5573C34.7176 12.3851 39.3807 16.8504 43.9307 23.1853C44.4985 23.9758 44.8634 24.9152 44.9529 25.9329C45.0157 26.6466 45.0157 27.4074 44.9529 28.1211C44.8634 29.1387 44.4985 30.0778 43.9307 30.8682C38.3872 38.5853 32.2059 40.6224 23.6856 44.8256C23.314 45.0089 22.8692 44.7434 22.8692 44.3306L24.5311 40.8958C15.8441 40.8958 10.8077 37.3772 6.13295 30.8682C4.62698 28.7712 4.61771 25.2955 6.133 23.1853C10.683 16.8491 15.3446 12.3859 23.7578 11.5573L24.1446 9.7297C23.2254 9.37534 22.5733 8.48757 22.5733 7.44744C22.5733 6.09576 23.6741 5 25.0319 5Z"
        fill="white"
      />
      <path
        d="M20.957 22.3738C21.8622 22.3738 22.596 23.1854 22.5961 24.1865V25.9998C22.596 27.001 21.8622 27.8126 20.957 27.8126C20.0518 27.8126 19.318 27.001 19.3179 25.9998V24.1865C19.318 23.1854 20.0518 22.3738 20.957 22.3738Z"
        fill="url(#paint0_linear_4901_62176)"
      />
      <path
        d="M20.957 22.3738C21.8622 22.3738 22.596 23.1854 22.5961 24.1865V25.9998C22.596 27.001 21.8622 27.8126 20.957 27.8126C20.0518 27.8126 19.318 27.001 19.3179 25.9998V24.1865C19.318 23.1854 20.0518 22.3738 20.957 22.3738Z"
        fill="#FFC300"
      />
      <path
        d="M29.1069 22.3738C30.0121 22.3738 30.7459 23.1854 30.746 24.1865V25.9998C30.7459 27.001 30.0121 27.8126 29.1069 27.8126C28.2017 27.8126 27.4679 27.001 27.4678 25.9998V24.1865C27.4679 23.1854 28.2017 22.3738 29.1069 22.3738Z"
        fill="url(#paint1_linear_4901_62176)"
      />
      <path
        d="M29.1069 22.3738C30.0121 22.3738 30.7459 23.1854 30.746 24.1865V25.9998C30.7459 27.001 30.0121 27.8126 29.1069 27.8126C28.2017 27.8126 27.4679 27.001 27.4678 25.9998V24.1865C27.4679 23.1854 28.2017 22.3738 29.1069 22.3738Z"
        fill="#FFC300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0319 5C26.3898 5 27.4906 6.09576 27.4906 7.44744C27.4906 8.48792 26.8379 9.37558 25.9182 9.7297L26.3055 11.5573C34.7176 12.3851 39.3807 16.8504 43.9307 23.1853C44.4985 23.9758 44.8634 24.9152 44.9529 25.9329C45.0157 26.6466 45.0157 27.4074 44.9529 28.1211C44.8634 29.1387 44.4985 30.0778 43.9307 30.8682C38.3872 38.5853 32.2059 40.6224 23.6856 44.8256C23.314 45.0089 22.8692 44.7434 22.8692 44.3306L24.5311 40.8958C15.8441 40.8958 10.8077 37.3772 6.13295 30.8682C4.62698 28.7712 4.61771 25.2955 6.133 23.1853C10.683 16.8491 15.3446 12.3859 23.7578 11.5573L24.1446 9.7297C23.2254 9.37534 22.5733 8.48757 22.5733 7.44744C22.5733 6.09576 23.6741 5 25.0319 5ZM11.7159 29.4516C12.2001 33.1124 15.0941 34.3314 18.7717 34.8134C22.7198 35.3308 27.3158 35.3345 31.2922 34.8134C34.9697 34.3314 37.8638 33.1124 38.348 29.4516C40.5821 12.5586 9.57666 13.2765 11.7159 29.4516Z"
        fill="url(#paint2_linear_4901_62176)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0319 5C26.3898 5 27.4906 6.09576 27.4906 7.44744C27.4906 8.48792 26.8379 9.37558 25.9182 9.7297L26.3055 11.5573C34.7176 12.3851 39.3807 16.8504 43.9307 23.1853C44.4985 23.9758 44.8634 24.9152 44.9529 25.9329C45.0157 26.6466 45.0157 27.4074 44.9529 28.1211C44.8634 29.1387 44.4985 30.0778 43.9307 30.8682C38.3872 38.5853 32.2059 40.6224 23.6856 44.8256C23.314 45.0089 22.8692 44.7434 22.8692 44.3306L24.5311 40.8958C15.8441 40.8958 10.8077 37.3772 6.13295 30.8682C4.62698 28.7712 4.61771 25.2955 6.133 23.1853C10.683 16.8491 15.3446 12.3859 23.7578 11.5573L24.1446 9.7297C23.2254 9.37534 22.5733 8.48757 22.5733 7.44744C22.5733 6.09576 23.6741 5 25.0319 5ZM11.7159 29.4516C12.2001 33.1124 15.0941 34.3314 18.7717 34.8134C22.7198 35.3308 27.3158 35.3345 31.2922 34.8134C34.9697 34.3314 37.8638 33.1124 38.348 29.4516C40.5821 12.5586 9.57666 13.2765 11.7159 29.4516Z"
        fill="#FFC300"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4901_62176"
          x1="45"
          y1="44.8846"
          x2="0.422324"
          y2="44.1296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset="1" stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4901_62176"
          x1="45"
          y1="44.8846"
          x2="0.422324"
          y2="44.1296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset="1" stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4901_62176"
          x1="45"
          y1="44.8846"
          x2="0.422324"
          y2="44.1296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset="1" stopColor="#0059FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MediumRiskIcon;
